import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fechar-solicitacao',
  templateUrl: './fechar-solicitacao.component.html',
  styleUrls: ['./fechar-solicitacao.component.scss']
})
export class FecharSolicitacaoComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<FecharSolicitacaoComponent>) { }

  ngOnInit() {

  }

  public fecharJanela() {

    this.dialogRef.close()
  }

  public cancelarSolicitacao(){

    this.dialogRef.close(true)
  }

}
